import React, { useState, useEffect, useCallback } from 'react';
import './Products.css';
import SearchBar from './components/SearchBar/SearchBar';
import ProductGrid from './components/ProductGrid/ProductGrid';
import { db, collection, getDocs, query, where } from '../../firebase';

function Products() {
  const [products, setProducts] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch products from Firebase when component mounts
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setIsLoading(true);
        const productsCollection = collection(db, 'products');
        const productsSnapshot = await getDocs(productsCollection);
        const productsList = productsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setProducts(productsList);
        setError(null);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError('Failed to load products. Please try again later.');
        // Fallback to sample data in case of error
        setProducts([
          {
            id: '1',
            name: 'Wireless Headphones',
            price: 99.99,
            store: 'Electronics Store',
            image: 'https://via.placeholder.com/150',
            url: 'https://example.com/headphones'
          },
          {
            id: '2',
            name: 'Smartphone',
            price: 699.99,
            store: 'Mobile Shop',
            image: 'https://via.placeholder.com/150',
            url: 'https://example.com/smartphone'
          },
          {
            id: '3',
            name: 'Laptop',
            price: 1299.99,
            store: 'Computer World',
            image: 'https://via.placeholder.com/150',
            url: 'https://example.com/laptop'
          },
          {
            id: '4',
            name: 'Smart Watch',
            price: 249.99,
            store: 'Gadget Zone',
            image: 'https://via.placeholder.com/150',
            url: 'https://example.com/smartwatch'
          }
        ]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleSearch = useCallback(async (searchTerm) => {
    try {
      setIsLoading(true);
      console.log('Searching for:', searchTerm);

      if (searchTerm.trim() === '') {
        // If search term is empty, show all products
        setSearchResults(products);
      } else {
        // In a production app, we would use Firebase's query capabilities
        // For simplicity, we'll filter the already fetched products
        const results = products.filter(product => 
          product.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setSearchResults(results);
      }
      setHasSearched(true);
      setError(null);
    } catch (err) {
      console.error('Error searching products:', err);
      setError('Failed to search products. Please try again.');
    } finally {
      setIsLoading(false);
    }
  }, [products]);

  return (
    <div className="home-container">
      <h1 className="app-title">Price Scope</h1>
      <p className="app-subtitle">Find the best deals across the web</p>

      <SearchBar onSearch={handleSearch} />

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      {isLoading ? (
        <div className="loading-message">
          Loading products...
        </div>
      ) : (
        hasSearched ? (
          <ProductGrid products={searchResults} />
        ) : (
          <ProductGrid products={products} />
        )
      )}
    </div>
  );
}

export default Products;
